import Box from '@mui/material/Box';
import Modal, { ModalProps } from '@mui/material/Modal';
import { FC } from 'react';

export const FullScreenModal: FC<ModalProps> = ({ children, ...modalProps }) => {
  return (
    <Modal {...modalProps}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'white',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
        }}
      >
        {children}
      </Box>
    </Modal>
  );
};
